import { Component, OnInit, inject, signal } from '@angular/core';
import { CardComponent } from '../../components/card/card.component';
import { RibbonComponent } from '../../components/ribbon/ribbon.component';
import { LinkComponent } from '../../components/link/link.component';
import { CardTitleComponent } from '../../components/card-title/card-title.component';
import { StepsComponent } from '../../components/steps/steps.component';
import { FeedbackCardComponent } from '../../components/feedback-card/feedback-card.component';
import { stepData } from './content';
import { MapComponent } from '../../components/map/map.component';
import { OSMResponse } from '../../api/portal/portal.service.interface';
import { firstValueFrom } from 'rxjs';
import { PortalService } from '../../api/portal/portal.service';

@Component({
  selector: 'app-wild-oats-mapping-page',
  imports: [
    CardComponent,
    RibbonComponent,
    LinkComponent,
    CardTitleComponent,
    StepsComponent,
    FeedbackCardComponent,
    MapComponent,
  ],
  templateUrl: './wild-oats-mapping-page.component.html',
  styleUrl: './wild-oats-mapping-page.component.css',
})
export class WildOatsMappingComponent implements OnInit {
  private portal = inject(PortalService);

  protected steps = stepData;
  protected mapHeight = '800px';
  protected isLoading = signal(false);
  protected mapFeatures = signal<OSMResponse>({ features: [] });

  public ngOnInit() {
    this.loadMapData();
  }

  protected goToFeedback() {
    const location = window.location.href;
    return location.includes('#') ? location : location + '#feedback';
  }

  private async loadMapData() {
    this.isLoading.set(true);
    try {
      this.mapFeatures.set(await firstValueFrom(this.portal.getExampleHeatmapData()));
    } finally {
      this.isLoading.set(false);
    }
  }
}
